/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Skill
 */
export interface Skill {
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    type: SkillTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    origin?: SkillOriginEnum;
    /**
     * 
     * @type {string}
     * @memberof Skill
     */
    seoUrl?: string;
}


/**
 * @export
 */
export const SkillTypeEnum = {
    Global: 'GLOBAL',
    Functional: 'FUNCTIONAL'
} as const;
export type SkillTypeEnum = typeof SkillTypeEnum[keyof typeof SkillTypeEnum];

/**
 * @export
 */
export const SkillOriginEnum = {
    Manual: 'MANUAL',
    Suggestion: 'SUGGESTION'
} as const;
export type SkillOriginEnum = typeof SkillOriginEnum[keyof typeof SkillOriginEnum];


/**
 * Check if a given object implements the Skill interface.
 */
export function instanceOfSkill(value: object): value is Skill {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    return true;
}

export function SkillFromJSON(json: any): Skill {
    return SkillFromJSONTyped(json, false);
}

export function SkillFromJSONTyped(json: any, ignoreDiscriminator: boolean): Skill {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'label': json['label'],
        'type': json['type'],
        'origin': json['origin'] == null ? undefined : json['origin'],
        'seoUrl': json['seoUrl'] == null ? undefined : json['seoUrl'],
    };
}

export function SkillToJSON(value?: Skill | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'label': value['label'],
        'type': value['type'],
        'origin': value['origin'],
        'seoUrl': value['seoUrl'],
    };
}

